import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: images/assign-user.svg; its strokes are one viewBox unit wide.
export const AssignUserIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function AssignUserIcon(props, ref) {
    return (
      <BaseIcon ref={ref} viewBox="0 0 18 15" strokeWidth={1} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 14.5C4.10457 14.5 5 13.6046 5 12.5C5 11.3954 4.10457 10.5 3 10.5C1.89543 10.5 1 11.3954 1 12.5C1 13.6046 1.89543 14.5 3 14.5Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 4.5C15.1046 4.5 16 3.60457 16 2.5C16 1.39543 15.1046 0.5 14 0.5C12.8954 0.5 12 1.39543 12 2.5C12 3.60457 12.8954 4.5 14 4.5Z"
          fill="currentColor"
        />
        <path d="M3 7.5V5.5C3 3.84315 4.34315 2.5 6 2.5H9" />
        <path d="M7 0.5L9 2.5L7 4.5" />
        <path
          d="M16 15H12V11L10 9V6H18V9L16 11V15Z"
          fill="currentColor"
          stroke="none"
        />
      </BaseIcon>
    );
  },
);
